<template>
    <div style="margin-bottom: 0.5rem; margin-top: 2rem;">
        <div class="wh100" layout="row top-left">
            <div>
                <router-link class="me pad-left" to="/">Björn Acker <span></span></router-link>
            </div>

            <div class="pad-right" self="right">
                <router-link to="/" :class="{active: current=='work'}" @click.native="current='work'">Work</router-link>
                <router-link to="/about" :class="{active: current=='about'}" @click.native="current='about'">About</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "top-bar",
        data() {
            return {
                current: 'work'
            }
        },
        created() {
            this.$bus.$on('loadpage', (path) => {
                setTimeout(() => {
                    this.current = path == '/about' ? 'about' : 'work';
                }, 200);

            });
        },
        methods: {
            click(nav) {
                console.log(nav);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pad-left {
        padding-left: 1px;
    }

    .pad-right {
        padding-right: 3px;
    }

    span {
        /*font-size: 2.5rem;*/
    }

    .active {
        font-weight: 700;
    }

    .me {
        margin-left: 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: black;

        span {
            font-weight: 100;
        }
    }

    a {
        margin-left: 0.5rem;
        color: #151515;
        font-weight: 100;
    }

    a:after {

        content: "";
    }
</style>
